import {
  EMAIL_ERROR,
  FULLNAME_ERROR,
  PASSWORD_ERROR,
  CONFIRM_PASSWORD_ERROR,
  TOGE_ERROR,
  PHONE_ERROR,
} from "constants/messages/error";

// eslint-disable-next-line import/prefer-default-export
export const errorMessage = {
  email: EMAIL_ERROR,
  fullname: FULLNAME_ERROR,
  tel: PHONE_ERROR,
  toge: TOGE_ERROR,
  plainPassword: PASSWORD_ERROR,
  confirmPassword: CONFIRM_PASSWORD_ERROR,
};
